import React, { useContext, useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { useTranslation } from "react-i18next";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext";
import { IProduct } from "@sbi-international/boutik.gatsby.plugin.services";
import { AddItemButton } from "@sbi-international/boutik.gatsby.plugin.checkout";
import { getAvailability } from "../../../utils/productAvailabilityInfo";
import { ProductPrice } from "../../price/ProductPrice";
import { ProductStock } from "@sbi-international/boutik.gatsby.plugin.components";
import PriceNotice from "./PriceNotice";

type ProductSummaryInfoProps = {
    product: Queries.ProductsJson;
    currentPrice?: number;
};

export default function ProductSummaryInfo(props: ProductSummaryInfoProps) {
    const { product } = props;
    const [productData, setProductData] = useState<IProduct>();
    const servicesContext = useContext(ServicesContext);
    const productService = servicesContext?.magento.productService;

    const { t } = useTranslation("templatePages");

    const productCode = product.code ? (product.code as string) : "";

    useEffect(() => {
        productService.operations.getProduct(productCode).then((productLive) => {
            productLive && setProductData(productLive);
        });
    }, []);

    const { currentLocale } = usePageLocalization();

    const data = useStaticQuery(
        graphql`
            query {
                productSummaryPromo: allProductsJson(
                    filter: { code: { eq: "product-summary-promo" } }
                ) {
                    nodes {
                        code
                        attributes {
                            content {
                                values {
                                    en_CA
                                    en_US
                                    fr_CA
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    const productSummaryPromo = data.productSummaryPromo.nodes[0].attributes.content.values[0][
        currentLocale
    ].split("\n") as string[];

    return (
        <div className="summaryInfo">
            {!!productData?.currentPrice?.discount?.amountOff && (
                <span className="badge sale">
                    - {productData?.currentPrice?.discount?.amountOff}$ {t("discount")}
                </span>
            )}

            <ProductPrice
                currentPrice={productData?.currentPrice}
                prefixClassName="product-summary-info"
            />
            <PriceNotice product={productData} />
            <ProductStock
                currentStock={productData?.currentStock}
                type="medium"
                isCustomMade={false}
            />

            <div className="addToCart">
                <AddItemButton
                    type={"large"}
                    product={productData}                    
                />
            </div>
            <hr />
            <div className="promo-text">
                {productSummaryPromo.map((text, index) => (
                    <p key={index}>{text}</p>
                ))}
            </div>
        </div>
    );
}
